import { ListMyPlan } from "../constants/myPlanConstants";

const initState = {
  listMyPlan: [],
};

export const ListMyPlanReducer = (state = initState, action) => {
  switch (action.type) {
    case ListMyPlan.CREATE_PLAN_SUCCESS:
      return { ...state, listMyPlan: [...state.listMyPlan, action.payload] };
    default:
      return state;
  }
};
